
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import SEO from '@/components/SEO';

const GetVIP = () => {
  const { openModal, isModalOpen } = useEarlyAdopter();
  const navigate = useNavigate();
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    if (!isModalOpen) {
      const source = `Direct VIP Page - ${window.location.pathname}`;
      openModal(source);
      setAttempted(true);
    }
  }, []);

  // If modal is closed after user dismisses it (not on first render), redirect home
  useEffect(() => {
    if (attempted && !isModalOpen) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isModalOpen, attempted, navigate]);

  // Always render SEO + static content so pre-renderers cache correct meta tags.
  // Real users will see the modal overlay; pre-renderers see this fallback page.
  return (
    <>
      <SEO
        title="Get VIP Early Access - SeniorThrive"
        description="Join our exclusive early access community and be the first to experience SeniorThrive's revolutionary platform for aging at home."
        keywords="VIP early access, SeniorThrive early access, exclusive preview, senior care platform"
        canonical="https://seniorthrive.com/get-vip"
      />

      <main className="min-h-screen flex items-center justify-center">
        <div className="text-center max-w-lg mx-auto px-4">
          <h1 className="text-3xl font-bold text-foreground mb-4">Get VIP Early Access</h1>
          <p className="text-muted-foreground mb-6">
            Join our exclusive early access community and be the first to experience
            SeniorThrive's platform for safe, independent living at home.
          </p>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-sm text-muted-foreground">Opening signup...</p>
        </div>
      </main>
    </>
  );
};

export default GetVIP;
